/**
 * While waiting for the complete overhaul of roles, I prefer to keep both types
 * because in some cases the simple string takes up less space in the code + ever used everywhere
 */

export enum ROLES {
    NONE = "none",
    OWNER = "owner",
    VIEW_ONLY = "view-only",
    ACCOUNTANT = "accountant",
    RIGHTS_MANAGER = "rights_manager",
    STOCK_MANAGER = "stock_manager",
    AGREEMENT_ADMIN = "agreement_admin",
    AGREEMENT_MANAGER = "agreement_manager",
    AGREEMENT_CONTRIBUTOR = "agreement_contributor",
}
